/** True when registration runs inside the React Native WebView shell. */
export function isRegistrationWebViewHost(): boolean {
  if (typeof window === "undefined") return false;
  const w = window as unknown as {
    ReactNativeWebView?: { postMessage?: (m: string) => void };
    isWebView?: boolean;
  };
  return typeof w.ReactNativeWebView?.postMessage === "function" || w.isWebView === true;
}
